import React from 'react';
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import { FiX } from "react-icons/fi";

const MobileMenu = ({show, onClose}) => {
    const elements = document.querySelectorAll('.popup-mobile-menu .has-droupdown > a');
    const elementsTwo = document.querySelectorAll('.popup-mobile-menu .with-megamenu > a');
    for (let idx = 0; idx < elements.length; idx++) {
        elements[idx].onclick = function () {
            this.parentElement.querySelector('.submenu').classList.toggle('active');
            this.classList.toggle('open');
        };
    }
    for (let idxTwo = 0; idxTwo < elementsTwo.length; idxTwo++) {
        elementsTwo[idxTwo].onclick = function () {
            this.parentElement.querySelector('.rn-megamenu').classList.toggle('active');
            this.classList.toggle('open');
        };
    }
    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`}>
            <div className="inner">
                <div className="header-top">
                    <Logo 
                        image={`${process.env.PUBLIC_URL}/images/logo/logos.png`}
                        image2={`${process.env.PUBLIC_URL}/images/logo/logos.png`}
                    />
                    <div className="close-menu">
                        <span className="close-button" onClick={onClose}><FiX /></span>
                    </div>
                </div>
                <Nav />
            </div>
        </div>
    )
}
export default MobileMenu;